import { embeddedIssuePreloadLayoutBuilder } from '@atlassian/jira-issue-preload-layout/src/index.tsx';
import { LazyIssueApp } from '@atlassian/jira-lazy-issue-app/src/LazyIssueApp.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { staticProjectSidebarNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { staticSidebarShortcutsResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-sidebar-shortcuts/index.tsx';
import AsyncSidebarNextGen from '@atlassian/jira-navigation-apps-sidebar-next-gen/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { composeLayouts } from '@atlassian/jira-route-layout/src/GlobalComponent.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { nextGenRoadmapResource } from '@atlassian/jira-router-resources-roadmap/src/services/next-gen-roadmap/index.tsx';
import { softwareTimelineRoute } from '@atlassian/jira-router-routes-software-timeline-routes/src/softwareTimelineRoute.tsx';
import { RoadmapSkeleton } from '@atlassian/jira-skeletons/src/ui/roadmap/RoadmapSkeleton.tsx';
import { AsyncHorizontalNavJira } from '@atlassian/jira-horizontal-nav/src/async.tsx';
import { softwareProjectLayoutCode } from '@atlassian/jira-software-project-layout/src/index.tsx';
import { resourceWithCondition } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
import { aiEntitlementResource } from '@atlassian/jira-router-resources-ai-entitlement/src/services/index.tsx';
import { projectThemeResource } from '@atlassian/jira-router-resources-project-theme/src/index.tsx';
import { getIsSoftwareThemingEnabled } from '@atlassian/jira-project-theme-providers/src/utils/getIsSoftwareThemingEnabled.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import {
	softwareTimelinePageEntrypoint,
	softwareHarmonisedTimelinePageEntrypoint,
} from './ui/spa/roadmap/index.tsx';

export const softwareTimelineRouteEntry = createEntry(softwareTimelineRoute, () => ({
	group: 'software',
	skeleton: RoadmapSkeleton,

	layout: composeLayouts(
		softwareProjectLayoutCode,
		embeddedIssuePreloadLayoutBuilder([{ query: ['selectedIssue'] }]),
	),

	navigation: {
		menuId: MENU_ID.PROJECTS,
		sidebar: AsyncSidebarNextGen,
		horizontal: AsyncHorizontalNavJira,
	},

	resources: [
		...getNavigationResources(),
		// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
		projectContextResource,
		staticSidebarShortcutsResource,
		staticProjectSidebarNavigationResource,
		// end of resources expanded from getNavigationSidebarProjectResource
		nextGenRoadmapResource,
		resourceWithCondition(() => getIsSoftwareThemingEnabled(), projectThemeResource),
		resourceWithCondition(() => fg('ai_sprint_goal_gate'), aiEntitlementResource),
	],

	preloadOptions: {
		earlyChunks: ['software-roadmap-early-entry'],
	},

	afterPaint: [LazyIssueApp],
	entryPoint: () =>
		// eslint-disable-next-line jira/ff/no-preconditioning
		fg('timeline_harmonisation_m3_targeting') &&
		expValEquals('jira_timeline_harmonisation_m3', 'isEnabled', true)
			? softwareHarmonisedTimelinePageEntrypoint
			: softwareTimelinePageEntrypoint,
	ufoName: 'next-gen-roadmap',
	supportsPreviewPanel: true,

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-software-timeline-entries/src/softwareTimelineRouteEntry.tsx',
			whichExportToUse: 'softwareTimelineRouteEntry',
		},

		enabled: true,
	},
}));
